import { render, staticRenderFns } from "./AGCCheckbox.vue?vue&type=template&id=36abffda&scoped=true&"
import script from "./AGCCheckbox.vue?vue&type=script&lang=js&"
export * from "./AGCCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AGCCheckbox.vue?vue&type=style&index=0&id=36abffda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36abffda",
  null
  
)

export default component.exports